module.exports = __webpack_public_path__ + "media/images/Share2-5fee8e35c43f22f8ee4cc32e73b30321.svg";